module.exports = __webpack_public_path__ + "img/business.cb7502a1.png";